import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import ProductsSection from "../components/newHomePage/productsSection"
import ServicesSection from "../components/newHomePage/servicesSection"
import BannerSection from "../components/newHomePage/bannerSection"
import DataConnectionsSection from "../components/newHomePage/dataConnectionSection"
import ClientsSection from "../components/newHomePage/clientsSection"
import MeetWersel from "../components/cards/meetwersel"
import Benefits from "../components/serviceCards/benefits"
// import Helmet from "react-helmet"
// import { withPrefix } from "gatsby"
// import Header from "../components/header/header"
// import Cookie from "../components/modals/cookie/Cookie"
// import SubscriptionSection from "../components/newHomePage/subscriptionSection"
import benefits from "../images/benefits.png"
import NewProducts from "../components/cards/newproducts/index"
import WhyService from "../components/newHomePage/whyService"
import product1 from "../images/AI-analytics.png"
import product2 from "../images/data-management.png"
import product3 from "../images/flexi.png"
import product4 from "../images/enterprise.png"
import product5 from "../images/product_5.png"
import Product1 from "../images/products/people-ai-analytics.png"
import Product2 from "../images/products/data-management.png"
import Product3 from "../images/products/flexible-collaboration.png"
import Product4 from "../images/products/enterprise-search.png"
import Product5 from "../images/products/learn-with-wersel.png"
import icon1 from "../images/1.png"
import icon2 from "../images/2.png"
import icon3 from "../images/3.png"
import icon4 from "../images/4.png"
import icon5 from "../images/5.png"

const HomePage = ({ data, location: { pathname } }) => {
  const sectionData = {
    werselData: {
      mainTitle: "How Wersel WorkDesk Helps Businesses to Grow Success",
      subTitle: `Wersel Workdesk consolidates all of the data in one single platform providing your organization with complete insights for growth to success and also providing bottom-line benefits by automating manual operations.`,
    },
    tags: [
      {
        tag: "Performance Driver",
        // tagline: "Wersel is an excellent and easy-to-use holistic platform that helps track employees’ performance effortlessly.",
        color: "#BAD681",
      },
      {
        tag: "Objectives & Key Results & Goals",
        // tagline:
        //   "Using Wersel, businesses can assign individual goals and OKRs to employees.",
        color: "#92BA47",
      },
      {
        tag: "Analyse People Pulse",
        // tagline: "Businesses that value employee opinions grow fast and efficiently.",
        color: "#3E9B39",
      },
      {
        tag: "Data Privacy & Security",
        // tagline:
        //   "Wersel offers an advanced and AI-powered dynamic employee development facility.",
        color: "#4b744a",
      },
      // {
      //   tag: "Data-Driven Decisions",
      //   // tagline:
      //   //   "Wersel gives automated analyses of employee performance driven by performance data.",
      //   color: "#0F270E",
      // },
    ],
    clientsSection: {
      title: "Clients Who Trust Us !!",
      content: `Wersel is a favourite choice of brands all across the globe. Companies such as\n Astro, Digi, Maxis and Cosmoderm have chosen us for employee success.`,
    },
    pointsTitle: "Benefits of Wersel",
    points: [
      {
        title: "Circle of Trust",
        icon: icon1,
        color: '#EB5882',
        content:
          "Using the Wersel platform, businesses can build a relationship of trust among the workforce.",
      },
      {
        title: "Success",
        icon: icon2,
        color: '#92BA47',
        content:
          "Wersel is a business-success platform that enables businesses to gain long-term success.",
      },
      {
        title: "Liberty",
        icon: icon3,
        color: '#07B1C8',
        content:
          "Wersel allows workforce to feel independent & free from any boundations that limit productivity.",
      }
    ],
    points_1: [
      {
        title: "AI & Data Driven Enterprises ",
        icon: icon4,
        color: '#3E8D5A',
        content:
          "With AI and data-based practices, you can maintain legitimacy in your organization.",
      },
      {
        title: '',
        url: benefits
      },
      {
        title: "Use Data to Help Employees Excel",
        icon: icon5,
        color: '#8D1749',
        content:
          "Companies can track employees' performance & use the analysis of that data to get insights into it.",
      },
    ],
    points_1_mob: [
      {
        title: "AI & Data Driven Enterprises ",
        icon: icon4,
        color: '#3E8D5A',
        content:
          "With AI and data-based practices, you can maintain legitimacy in your organization.",
      },
      {
        title: "Use Data to Help Employees Excel",
        icon: icon5,
        color: '#8D1749',
        content:
          "Companies can track employees' performance & use the analysis of that data to get insights into it.",
      },
    ],
    products: [
      {
        featureTitle: "1. People & AI Analytics",
        featureDescription:
          "Wersel Workdesk keeps track of the growth and performance of your workforce both People & AI, no matter where they are in the world, Wersel's WorkDesk centralizes all business data in one location with Blockchain enabled Data Security & Privacy.",
        featureImage: Product1,
        imagePosition: "right",
        url: "/people-AI-analytics/",
        btnLabel: 'Book Demo',
        btnLink: '/contact',
      },
      {
        featureTitle: "2. Data Management",
        featureDescription:
          "Wersel Workdesk centralizes all organizational data in one location and gives you real-time insight into complete employee data, marketing data, sales data, social media data, business data and fintech data. Wersel Workdesk turns data into insights to help and accelerate business growth towards the future.",
        featureImage: Product2,
        imagePosition: "left",
        hack: "hack-2500",
        url: "/data-management/",
        btnLabel: 'Book Demo',
        btnLink: '/contact',
      },
      {
        featureTitle: "3.Flexible Collaboration",
        featureDescription:
          "Wersel Workdesk is the all-in-one workspace to keep people, projects, data & functions aligned across your organization and boosts productivity by enabling teams of all shapes and sizes to complete tasks based on project objectives more successfully.",
        featureImage: Product3,
        imagePosition: "right",
        url: "/flexible-collaboration/",
        btnLabel: 'Book Demo',
        btnLink: '/contact',
      },
      {
        featureTitle: "4.Enterprise Search",
        featureDescription:
          "Wersel Workdesk offers Google-like search functionality that delivers secure, powerful & highly configurable search to your team, providing an elegant single view of content no matter where it lives, leading to faster, more informed.",
        featureImage: Product4,
        imagePosition: "left",
        url: "/enterprise-search/",
        btnLabel: 'Book Demo',
        btnLink: '/contact',
      },
      {
        featureTitle: "5.Learn with Wersel",
        featureDescription:
          `At Wersel, we believe in the power of data-driven decision-making. That's why we offer a comprehensive learning and development program in data science and related fields through our online platform, "Learn with Wersel." Our fast-track approach includes programs in business and data analysis, data engineering and analytics, AI/ML, and tech entrepreneurship.`,
        featureImage: Product5,
        imagePosition: "right",
        url: "/learn-with-wersel",
        btnLabel: 'Course Registration',
        btnLink: 'https://wersel.world/learn',
      },
      // {
      //   featureTitle: "HR Software Analysis",
      //   featureDescription:
      //     "The HRs can make data-driven decisions using Wersel. The features such as AI-powered sentiment analysis, unified dashboards, and continuous analytics helps HR drive innovation and impact. The platform offers a connection between employee insights and decision-making.",
      //   featureImage: product5,
      //   imagePosition: "right",
      //   hack: "hack-2500",
      //   stylePadding: '10rem'
      //   // url: "/products/dashx/",
      // },
    ],
  }
   const { points, points_1, points_1_mob, pointsTitle, products } = sectionData
  return (
    <Layout fixed="top" withBrand slidePosition={1}>
      <SEO
        description="Deliver a phenomenal experience to your targeted shoppers and ensure that your brand maintains its credibility in the market with our brand analytics platform"
        keywords="brand analytics, brand analytics platform, brand analytics software, wersel, wersel brand analytics, wersel data hub"
        title="Wersel - AI Enabled People Analytics & Insights Software"
        url="www.wersel.io/"
      />
      <BannerSection
        bannerImg={data?.banner?.childImageSharp?.fluid?.src}
        bannerBG={data?.bannerBG?.childImageSharp?.fluid?.src}
      />
      <MeetWersel
        title="Wersel WorkDesk"
        platformText={`A Collaborative platform that unites Data, People & AI to help business to manage their organizational data, workforce and project productivity with highly focusing on the objectives of organizational growth. It is an easy-to-use collaborative, search, visualize, blockchain & data security tool to build a data-driven Organization.`}
      />
      <NewProducts features={products} homePage={true} />
      <ServicesSection
        werselData={sectionData.werselData}
        tags={sectionData.tags}
      />
      <Benefits points={points} points_1={points_1} points_1_mob={points_1_mob} pointsTitle={pointsTitle} />
      <WhyService
        discoverx={data?.discoverx?.childImageSharp?.gatsbyImageData}
        dashx={data?.dashx?.childImageSharp?.gatsbyImageData}
        glassx={data?.glassx?.childImageSharp?.gatsbyImageData}
      />
      {/* <ProductsSection
        discoverx={data?.discoverx?.childImageSharp?.gatsbyImageData}
        dashx={data?.dashx?.childImageSharp?.gatsbyImageData}
        glassx={data?.glassx?.childImageSharp?.gatsbyImageData}
      /> */}
      <DataConnectionsSection />
      <ClientsSection
        title={sectionData.clientsSection.title}
        content={sectionData.clientsSection.content}
        clients={data?.allFile?.edges}
      />
    </Layout>
  )
}

export const bannerQuery = graphql`
  query BannerQuery {
    banner: file(relativePath: { eq: "homepage_banner.png" }) {
      childImageSharp {
        fluid(maxWidth: 650) {
          src
        }
      }
    }
    bannerBG: file(relativePath: { eq: "bannerrow_background.png" }) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    discoverx: file(relativePath: { eq: "discoverx.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    dashx: file(relativePath: { eq: "dashx.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    glassx: file(relativePath: { eq: "glassx.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    allFile(filter: { relativeDirectory: { eq: "clients" } }) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData(placeholder: NONE)
          }
        }
      }
    }
  }
`

export default HomePage
